import * as React from 'react';

export class TitleWithTextData extends React.Component<any, any> {

    public render() {
        const { title, childrenRows, className } = this.props;
        
        return (<div className={className}>
            <label className={`${title.cssClass}`}>{title.text}</label>
            <div className="m-b-4">
                {childrenRows.data.map((x, i) => 
                    <div key={`${className}__children-${i}`}><label aria-label={x.ariaLabel} className={`${className}__children ${childrenRows.cssClass}`}>{x.content}</label></div>
                )}
            </div>
        </div>);
    }
}